angular.module('reporting.dashboards.filters')
    .filter('ellipseAt', function () {
    'use strict';
    return function (input, maxLength, customEllipsis) {
        //TODO: For fun. Be able to give it a negative maxLength
        if (typeof input === 'string' && input.length > maxLength) {
            input = input.substring(0, maxLength); //TODO: substring(0, maxLength-3)?
            return input.replace(/[\s\uFEFF\xA0]+$/g, '') + (customEllipsis || '...');
        }
        return input;
    };
});
